import React from 'react';
import {
  Skeleton,
  SkeletonItem,
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';

const useEntitySelectionMenuShimmerStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    gap: '8px',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
  },
});

export const EntitySelectionMenuShimmerRow = () => {
  const styles = useEntitySelectionMenuShimmerStyles();

  return (
    <div className={mergeClasses(styles.row, 'entity-selection-menu-shimmer')}>
      <SkeletonItem shape="circle" size={12} />
      <div className={styles.content}>
        <SkeletonItem shape="rectangle" style={{ height: '16px', width: '99%', opacity: 0.7 }} />
        <SkeletonItem shape="rectangle" style={{ height: '14px', width: '40%', opacity: 0.7 }} />
      </div>
    </div>
  );
};

export const EntitySelectionMenuShimmer = () => (
  <Skeleton>
    <EntitySelectionMenuShimmerRow />
    <EntitySelectionMenuShimmerRow />
    <EntitySelectionMenuShimmerRow />
    <EntitySelectionMenuShimmerRow />
  </Skeleton>
);
